<template>
<div :class="_class">
    <slot></slot>
</div>
</template>

<script>
export default {
    props: {
        type: {
            default: 'checkbox'
        },
        hor: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        _class: function() {
            let _class = []

            _class.push('kt-'+this.type)

            if(this.hor === true) {
                _class.push('kt-'+this.type+'-inline')
            }

            if(this.hor === false) {
                _class.push('kt-'+this.type+'-list')
            }

            return _class
        }
    }
}
</script>